var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgFooterPlayIcon = function SvgFooterPlayIcon(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 9.7714,
    height: 10.613,
    viewBox: "0 0 9.7714 10.613",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.40527 5.33608V5.27261L0.228271 0.22744C0.12912 0.339338 0.065918 0.511005 0.065918 0.742577V9.86733C0.065946 10.0985 0.128182 10.2706 0.227051 10.3825L5.40527 5.33608Z",
    fill: "#97969A",
    stroke: "#1A1A1A",
    strokeWidth: 0.105794
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.29614 5.843C9.57987 5.68546 9.70508 5.48737 9.70508 5.30467C9.70485 5.12214 9.57961 4.92516 9.29614 4.76878L7.22827 3.62254L5.53638 5.27415V5.33763L7.22705 6.98924L9.29614 5.843Z",
    fill: "#97969A",
    stroke: "#1A1A1A",
    strokeWidth: 0.105794
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_0_21",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.25835 7.04858L5.47096 5.30586L0.196053 10.4494C0.392301 10.6506 0.712329 10.6748 1.07626 10.4737L7.25835 7.04858"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.25835 7.04858L5.47096 5.30586L0.196053 10.4494C0.392301 10.6506 0.712329 10.6748 1.07626 10.4737L7.25835 7.04858",
    fill: "#97969A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.47096 5.30586L5.37863 5.21118L5.47095 5.12116L5.56328 5.21118L5.47096 5.30586ZM0.196053 10.4494L0.101398 10.5418L0.00901968 10.4471L0.103729 10.3547L0.196053 10.4494ZM1.07626 10.4737L1.14035 10.5893L1.14023 10.5894L1.07626 10.4737ZM7.25835 7.04858L7.16603 7.14326L5.37864 5.40055L5.47096 5.30586L5.56328 5.21118L7.35067 6.95389L7.25835 7.04858ZM5.47096 5.30586L5.56328 5.40054L0.288376 10.5441L0.196053 10.4494L0.103729 10.3547L5.37863 5.21118L5.47096 5.30586ZM0.196053 10.4494L0.290707 10.3571C0.43013 10.5 0.678504 10.5424 1.01229 10.3579L1.07626 10.4737L1.14023 10.5894C0.746153 10.8072 0.354472 10.8012 0.101398 10.5418L0.196053 10.4494ZM1.07626 10.4737L1.01217 10.358L7.19426 6.9329L7.25835 7.04858L7.32244 7.16425L1.14035 10.5893L1.07626 10.4737Z",
    fill: "#1A1A1A",
    mask: "url(#path-3-inside-1_0_21)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.14796 3.57803L1.04444 0.195467C0.727666 0.0222157 0.465191 0.0350381 0.293709 0.16739L5.47071 5.21256L7.14796 3.57803Z",
    fill: "#97969A",
    stroke: "#1A1A1A",
    strokeWidth: 0.105794
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgFooterPlayIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/footer-play-icon.07ba7844e1d7edffe44ea08a47bfb03a.svg";